const state = {
  vanOffline: {
    state: 'home',
    item: {},
  }
}

const mutations = {
  setComponent(state, { component, item }) {
    state.vanOffline = {
      state: component,
      item: item,
    }
  },
}

const actions = {
  setComponent({ commit }, data) {
    commit('setComponent', data)
  },
}

const getters = {
  vanOffline: (state) => state.vanOffline
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
